// @ts-nocheck

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import MPBasketSwitch from '../components/MPBasketSwitch';
import { selectMPBasketSwitchProps } from '../selectors/computed/basket';

type MPBasketSwitchContainerProps = {
  className?: string;
  oddsId?: number;
};

const MPBasketSwitchContainer = ({ oddsId, ...ownProps }: MPBasketSwitchContainerProps) => {
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ oddsId, dispatch }), [dispatch, oddsId]);
  const licence = useSelector(selectRuntimeLicence);
  const { isVisible, card, ...switchProps } = useSelector((state) => selectMPBasketSwitchProps(state, selectorProps));

  const selectedProps = useMemo(
    () => ({
      card,
      licence,
      ...switchProps,
    }),
    [card, licence, switchProps],
  );

  useEffect(() => {
    switchProps.onToggle(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return isVisible && !!card ? <MPBasketSwitch {...enhancedProps} /> : null;
};

export default MPBasketSwitchContainer;
